import React from 'react';
import { css } from 'styled-components';
import { applyStyles } from 'util/helpers';
import CustomMedia from 'util/custom-media-query';
import { minResolution } from 'util/helpers';
import { throttle } from 'lodash';
import icBtnTopPC1x from 'assets/images/PC/@1x/ic_btn_top.png';
import icBtnTopPC2x from 'assets/images/PC/@2x/ic_btn_top@2x.png';
import icBtnTopSP2x from 'assets/images/SP/@2x/ic_btn_top@2x.png';
import icBtnTopSP3x from 'assets/images/SP/@3x/ic_btn_top@3x.png';
import icBtnTopPressPC1x from 'assets/images/PC/@1x/ic_btn_top_press.png';
import icBtnTopPressPC2x from 'assets/images/PC/@2x/ic_btn_top_press@2x.png';
import icBtnTopPressSP2x from 'assets/images/SP/@2x/ic_btn_top_press@2x.png';
import icBtnTopPressSP3x from 'assets/images/SP/@3x/ic_btn_top_press@3x.png';

class Jump extends React.Component {
  constructor(props) {
    super(props);

    this.scrollEvent = throttle(() => this.watchCurrentPosition(), 100);
    this.state = {
      visible: false
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.scrollEvent, true);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.scrollEvent, true);
  }

  watchCurrentPosition() {
    this.setState({ visible: this.scrollTop() >= 500 });
  }

  jumpTop() {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }

  scrollTop() {
    return Math.max(
      window.pageYOffset,
      document.documentElement.scrollTop,
      document.body.scrollTop
    );
  }

  render() {
    const { className } = this.props;

    return (
      <div className={className}>
        <button
          className={`jump-button ${this.state.visible ? 'visible' : 'hidden'}`}
          onClick={this.jumpTop}
        />
      </div>
    );
  }
}

const commonStyle = css`
  position: fixed;
  z-index: 9;

  .jump-button {
    padding: 0;
    border: 0;
    appearance: none;
    outline: none;
    background-color: transparent;
    cursor: pointer;
    transition: all 0.5s ease;
  }

  .hidden {
    visibility: hidden;
    opacity: 0;
  }

  .visible {
    visibility: visible;
    opacity: 1;
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  bottom: 80px;
  right: 80px;

  .jump-button {
    height: 96px;
    width: 96px;
    background-size: 96px;
    background-image: url('${icBtnTopPC1x}');

    &:hover,
    &:active {
      background-image: url('${icBtnTopPressPC1x}');
      cursor: pointer;
    }

    ${minResolution(2)`
      background-image: url('${icBtnTopPC2x}');

      &:hover,
      &:active {
        background-image: url('${icBtnTopPressPC2x}');
        cursor: pointer;
      }
    `}
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  bottom: 16px;
  right: 16px;

  .jump-button {
    height: 74px;
    width: 74px;
    background-size: 74px;

    ${minResolution(2)`
      background-image: url('${icBtnTopSP2x}');

      &:active {
        background-image: url('${icBtnTopPressSP2x}');
      }
    `}

    ${minResolution(3)`
      background-image: url('${icBtnTopSP3x}');

      &:active {
        background-image: url('${icBtnTopPressSP3x}');
      }
    `}
  }
`;

export default applyStyles(Jump)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/common/Jump/index.js